import { Modal, Box, Button, Snackbar, Alert } from "@mui/material";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { IDataCartes } from "../../../models/component/carteExplain/datacartes";
import { IDataCarte } from "../../../models/component/carteExplain/datacarte";
import MenuService from "../../../services/api/menu.service";
import { ICategorieMenu } from "../../../models/component/carteExplain/categories";
import AuthService from "../../../services/api/auth.service";
import { IDataCartePost } from "../../../models/component/carteExplain/datacartePost";
import { IDataCarteUpdate } from "../../../models/component/carteExplain/datacarteupdate";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "transparent",
  border: "2px solid #000",
};


  

const CarteAdmin = () => {
  const {
    register,
    handleSubmit,
    control,
    watch,
    resetField,
    setValue
  } = useForm();
    
  const [open, setOpen] = useState(false);
  const handleOpenModal = () => {
    resetField("dropdown")
    resetField("title")
    resetField("description")
    resetField("price")
    setUpdateModal(false)
    setOpen(true)
  };
  const handleCloseModal = () => {
    setOpen(false)
  };
  const [token, setToken] = useState<any>("");
  const [openFailed, setOpenFailed] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [message, setMessage] = useState(""); 
  const [updateModal,setUpdateModal] = useState(false);
  const [menuElementSelectedId, setMenuElementSelectedId] = useState<number>(0);

  const [arrayCarte, setArrayCarte] = useState<IDataCartes[]>([]);

  const [arrayCategories,setArrayGaleries] = useState<ICategorieMenu[]>([]);

  const handleCloseSnackbar = (event: any, reason: string) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenFailed(false);
  };
  const handleSuccessSnackbar = (event: any, reason: string) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccess(false);
  };

  const handleOpenModify = (valueElementMenu: IDataCarte,categorie:number) => {
    console.log("data : " ,valueElementMenu,categorie)
    resetField("dropdown")
    resetField("title")
    resetField("description")
    resetField("price")
    setMenuElementSelectedId(valueElementMenu.id)
    setValue("dropdown", categorie);
    setValue("title", valueElementMenu.name);
    setValue("description", valueElementMenu.description);
    setValue("price", valueElementMenu.price);
    setUpdateModal(true)
    setOpen(true);
  };


  const handleAddElementCarte = (value:IDataCartePost) => {
    console.log("Created" + value)
    MenuService.post(watch("dropdown"),value,token).then((r) => {
      console.log(r.data)
      if(r.status == 201){
        MenuService.getAllMenu().then((r) => {
          setArrayCarte(r.data)
          setMessage("Element ajouter à la carte");
          setOpenSuccess(true);
          setTimeout(() => {
            setOpenSuccess(false);
          }, 3000);
        })
      }
    }).catch((r) => {
      console.log(r)
      setMessage("Une erreur est survenue lors du traitement de votre demande. Veuillez réessayer plus tard.");
      setOpenFailed(true);
      setTimeout(() => {
        setOpenFailed(false);
      }, 3000);
    })
  }

  const handleUpdateElementCarte = (value: IDataCarte) => {
    console.log("update" + value)
    console.log("categori" + watch("dropdown"))
    MenuService.update(watch("dropdown"),value,token).then((r) => {
      if(r.status == 200) {
        MenuService.getAllMenu().then((r) => {
          setArrayCarte(r.data)
          setMessage("Element mise a jours dans carte");
          setOpenSuccess(true);
          setTimeout(() => {
            setOpenSuccess(false);
            setUpdateModal(false)
          }, 3000);
        })
      }
    }).catch((r) => {
      console.log(r)
      setMessage("Une erreur est survenue lors du traitement de votre demande. Veuillez réessayer plus tard.");
      setOpenFailed(true);
      setTimeout(() => {
        setUpdateModal(false)
        setOpenFailed(false);
      }, 3000);
    })
  }

  const handleDeleteElementCarte = (id:number) => {
    console.log("delete id" + id)
    MenuService.removeByProductId(id,token).then((r) => {
      if(r.status == 200){
        MenuService.getAllMenu().then((r) => {
          setArrayCarte(r.data)
          setMessage("Element supprimé de la carte");
          setOpenSuccess(true);
          setTimeout(() => {
            setOpenSuccess(false);
          }, 3000);
        })
      }
    }).catch((r) => {
      console.log(r)
      setMessage("Une erreur est survenue lors du traitement de votre demande. Veuillez réessayer plus tard.");
      setOpenFailed(true);
      setTimeout(() => {
        setOpenFailed(false);
      }, 3000);
    })
  }

  const onSubmit = handleSubmit((data) => {
    const dataModelCreate: IDataCartePost = {
      name: data.title,
      description: data.description,
      price: data.price,
    };
    const dataModelUpdate: IDataCarte = {
      id:menuElementSelectedId,
      name: data.title,
      description: data.description,
      price: data.price,
    };
    console.log("submit :", dataModelCreate);
    if(updateModal){
      handleUpdateElementCarte(dataModelUpdate);
    } else {
      handleAddElementCarte(dataModelCreate)
    }
    handleCloseModal()
  });

  useEffect(() => {
    if (AuthService.getUserConnected() != "" || AuthService.getUserConnected() != null) {
      setToken(AuthService.getUserConnected());
      MenuService.getAllCategorie().then((r) => {
        console.log(r)
        setArrayGaleries(r.data)
      })
      MenuService.getAllMenu().then((r) => {
        console.log(r)
        setArrayCarte(r.data)
      })
    }
  }, [token]);
  

    
  return (
    <>
      <Modal
        open={open}
        onClose={handleCloseModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="component-modal-event">
            <form onSubmit={onSubmit} className="container-form-event">
              <div className="component-dropdown-menu">
                <label htmlFor="dropdown">Selectionnez une categori:</label>
                <Controller
                  name="dropdown"
                  disabled={updateModal}
                  control={control}
                  rules={{ required: "This field is required" }}
                  render={({ field }) => (
                    <select {...field} id="dropdown">
                      <option value="">-- Choisir une categori --</option>
                      {
                        arrayCategories.map((value,index) => 
                          <option key={index} value={value.id}>{value.name}</option>
                        )
                      }     
                    </select>
                  )}
                />
              </div>
              <input
                className="input-form"
                {...register("title", { required: "Le titre est obligatoire" })}
                placeholder={"Titre"}
                type="text"
              />
              <input
                className="input-form"
                {...register("description", { required: "La description est obligatoire" })}
                placeholder={"Description"}
                type="text"
              />
              <input
                className="input-form"
                {...register("price", { required: "Le prix est obligatoire" })}
                placeholder={"Prix"}
                type="text"
              />
              {
                updateModal ? (
                  <button type="submit">Mise a jour du produit</button>
                ) : (
                  <button type="submit">Ajouter à la Carte</button>
                )
              }
            </form>
          </div>
        </Box>
      </Modal>
    
      <div className="view-carte-admin">
        <div className="header-carte">
          <div className="header-event-title">Cartes</div>
          <Button
            variant="contained"
            onClick={() => handleOpenModal()}
            sx={{ background: "rgb(34, 10, 110)",fontSize:30,width:"10px",height:40 }}
          >
            {"+"}
          </Button>
        </div>
        <div  className="br"/>
        <div className="container-carte">
          {
            arrayCarte.map((value,index) => 
              <div key={index} className="component-element-carte">
                <div className="title">Categorie : {value.name}</div>
                {
                  value.content.map((card,index) => 
                    <div key={index} className="container-content-element">
                      <div className="left-part-content-element">
                        <div className="subtitlte"><span>Titre Produit :</span> {card.name}</div>
                        <div className="subtitlte"><span>Description Produit:</span> {card.description}</div>
                        <div className="subtitlte"><span>Prix Produit :</span> {card.price} €</div>
                      </div>
                      <div className="right-part-content-element">
                        <Button
                          variant="contained"
                          onClick={() => handleOpenModify(card,value.id)}
                          sx={{ background: "rgb(255,255, 255)",fontSize:30,marginBottom:2 }}
                        >
                          <img style={{width:20,height:20}} src="/assets/icons/update.png" alt="" />
                        </Button>
                        <Button
                          variant="contained"
                          onClick={() => handleDeleteElementCarte(card.id)}
                          sx={{ background: "rgb(255,255, 255)",fontSize:30 }}
                        >
                          <img style={{width:20,height:20}} src="/assets/icons/delete.png" alt="" />
                        </Button>
                      </div>
                    </div>
                  )
                }
              </div>
            )
          }
        </div>
        <Snackbar open={openSuccess} autoHideDuration={6000} onClose={handleSuccessSnackbar}>
          <Alert severity="success" sx={{ width: "100%" }}>
            {message}
          </Alert>
        </Snackbar>
        <Snackbar open={openFailed} autoHideDuration={6000} onClose={handleCloseSnackbar}>
          <Alert severity="error" sx={{ width: "100%" }}>
            {message}
          </Alert>
        </Snackbar>
      </div>
    </>
  );
}

export default CarteAdmin